import { render, staticRenderFns } from "./CellAttributeEditor.vue?vue&type=template&id=6680233a"
import script from "./CellAttributeEditor.vue?vue&type=script&lang=ts"
export * from "./CellAttributeEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports